// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__1ehKd","Overlay":"Hero_Overlay__3uWp4","Text":"Hero_Text__1QXYB"};